export default __webpack_public_path__ + "static/media/wa-background.ab8484d1.png";